<script setup lang="ts">
import type { NuxtError } from '#app';

const isDev = import.meta.env.DEV;
const props = defineProps({
    error: Object as () => NuxtError,
});

// Get the status message from the error object
const statusMessage = computed(() => {
    return props.error?.statusMessage ?? props.error?.message;
});

const statusCode = computed(() => props.error?.statusCode);

if (isDev) {
    console.error(props.error);
}
</script>

<template>
    <Html>
        <Head>
            <title>Error {{ statusCode }}</title>
            <meta
                name="viewport"
                content="width=device-width, initial-scale=1"
            />
            <meta charset="utf-8" />
            <link rel="icon" href="/favicon.ico" />
        </Head>
        <Body class="bg-slate-800 min-h-screen relative">
            <div class="w-full relative h-full">
                <div
                    class="absolute inset-0 bg-gradient-to-tr from-slate-500 via-slate-700 to-slate-800 z-0"
                />

                <!-- <MemberAppHeader :is-active-member="isActiveMember" /> -->

                <main
                    class="flex flex-col items-center justify-center max-w-[970px] mx-auto min-h-[100vh]"
                >
                    <Error404
                        v-if="statusCode === 404"
                        :message="statusMessage"
                    />
                    <Error401 v-else-if="statusCode === 401" />
                    <Error403 v-else-if="statusCode === 403" />
                    <Error500 v-else-if="statusCode === 500" />

                    <div
                        v-if="isDev"
                        class="text-white text-lg whitespace-pre z-10"
                    >
                        {{ error?.stack }}
                    </div>
                </main>
            </div>
        </Body>
    </Html>
</template>
